import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = checking
    const [tenant, setTenant] = useState(null);

    useEffect(() => {
        const t = localStorage.getItem("pe_token");
        if (!t) {
            setUser(null);
            return;
        }
        api
            .get("/auth/me")
            .then((r) => {
                setUser(r.data.user);
                setTenant(r.data.tenant);
            })
            .catch(() => {
                localStorage.removeItem("pe_token");
                setUser(null);
            });
    }, []);

    const finish = (data) => {
        localStorage.setItem("pe_token", data.token);
        setUser(data.user);
        setTenant(data.tenant);
        return data.user;
    };

    const login = async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        if (!r.data.mfa) finish(r.data);
        return r.data;
    };

    const veracrossLogin = async (school_route, email, password) => {
        const r = await api.post("/auth/veracross/login", { school_route, email, password });
        if (!r.data.mfa) finish(r.data);
        return r.data;
    };

    const signup = async (payload) => {
        const r = await api.post("/auth/signup", payload);
        if (!r.data.mfa) finish(r.data);
        return r.data;
    };

    const mfaVerify = async (pending_token, code) => {
        const r = await api.post("/auth/mfa/verify", { pending_token, code });
        finish(r.data);
        return r.data;
    };

    const logout = () => {
        localStorage.removeItem("pe_token");
        localStorage.removeItem("pe_admin_token");
        setUser(null);
        setTenant(null);
    };

    const refresh = async () => {
        const r = await api.get("/auth/me");
        setUser(r.data.user);
        setTenant(r.data.tenant);
    };

    const impersonate = async (uid) => {
        const r = await api.post(`/admin/users/${uid}/impersonate`);
        const cur = localStorage.getItem("pe_token");
        if (cur) localStorage.setItem("pe_admin_token", cur);
        finish(r.data);
        return r.data.user;
    };

    const stopImpersonate = async () => {
        const admin = localStorage.getItem("pe_admin_token");
        if (admin) { localStorage.setItem("pe_token", admin); localStorage.removeItem("pe_admin_token"); }
        const r = await api.get("/auth/me");
        setUser(r.data.user);
        setTenant(r.data.tenant);
        return r.data.user;
    };

    return (
        <Ctx.Provider value={{ user, tenant, login, veracrossLogin, signup, mfaVerify, logout, refresh, setTenant, impersonate, stopImpersonate }}>
            {children}
        </Ctx.Provider>
    );
}
